module.exports = __webpack_public_path__ + "static/media/1.868710e5.jpg";